import { Button, IconButton, Radio, RadioGroup } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import { FormControl, FormControlLabel } from '@mui/material';
import React, { useEffect, useReducer, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CustomSearchSelect from '../../../../shared/form-controls/custom-search-select/Custom-Seacrh-Select';
import CustomTextField from '../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import { updateDevice } from '../../../../utils/devicesRestAPIUtils';
import { formDataValidate } from '../../../../utils/formUtils';
import { notificationManager } from '../../../../utils/NotificationUtils';
import { allLocationsSelector, allRoomsSelector } from '../../../property/propertySlice';
import { fetchDevices } from '../../configurationSlice';
import './Device-Create.scss';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../utils/loaderSlice';

const DevicesCreate = (props) => {
  const { toggleDrawer, category, hotelId, devicesEndpoint, showLoader = () => {} } = props;
  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    roomNumber: {
      value: '',
      fieldName: 'Select Room Number',
      errors: {},
      validations: ['required'],
      maxLength: 30,
      tab: 0,
    },
    location: {
      value: '',
      fieldName: 'Select Location',
      errors: {},
      validations: ['required'],
      maxLength: 30,
      tab: 0,
    },
    zoneName: {
      value: '',
      fieldName: 'Zone Name',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    serialNumber: {
      value: '',
      fieldName: 'Enter serial number',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    udId: {
      value: '',
      fieldName: 'Enter UDID',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    roomNumberLocationStatus: {
      value: 'room',
      fieldName: 'Room number Location status',
      validations: [],
      tab: 0,
    },
    serialNumberUdidStatus: {
      value: 'serial_no',
      fieldName: 'Serial number udid status',
      validations: [],
      tab: 0,
    },
  });

  const [roomNumbers, setRoomNumbers] = useState([]);
  const [locationList, setLocationList] = useState([]);
  const roomListData = useSelector(allRoomsSelector);
  const locationListData = useSelector(allLocationsSelector);
  const [roomSearchValue, setRoomSearchValue] = useState('');
  const [locationSearchValue, setlocationSearchValue] = useState('');
  const [isButtonInValid, setIsButtonInValid] = useState(true);
  const dispatch = useDispatch();

  const onSearchRoomList = async (searchRoom) => {
    setRoomSearchValue(searchRoom);
    if (searchRoom === '') return setRoomNumbers(roomListData);
    const filterList = await roomListData.filter((item) => {
      return item.number.toLowerCase().includes(searchRoom.toLowerCase());
    });
    return setRoomNumbers(filterList);
  };

  const onSearchLocationList = async (searchLocation) => {
    setlocationSearchValue(searchLocation);
    if (searchLocation === '') return setLocationList(locationListData);
    const filterList = await locationListData.filter((item) => {
      return item.name.toLowerCase().includes(searchLocation.toLowerCase());
    });
    return setLocationList(filterList);
  };

  const onCancel = (e) => {
    toggleDrawer('', false, '');
  };

  const handleSubmit = async () => {
    let payload = {};
    if (category) {
      payload = {
        uniquenumbertype: formData.serialNumberUdidStatus.value,
        uniquenumbervalue:
          formData.serialNumberUdidStatus.value === 'udid'
            ? formData.udId.value
            : formData.serialNumber.value,
        areatypeid:
          formData.roomNumberLocationStatus.value === 'room'
            ? formData.roomNumber.value
            : formData.location.value,
        areatype: formData.roomNumberLocationStatus.value,
        area_id: formData.zoneName.value,
        // hotel_id: "e088d4bf-3fb0-4a61-9cec-78dc9e92e314",
        hotel_id: hotelId,
        id: category.id,
      };
    } else {
      payload = {
        uniquenumbertype: formData.serialNumberUdidStatus.value,
        uniquenumbervalue:
          formData.serialNumberUdidStatus.value === 'udid'
            ? formData.udId.value
            : formData.serialNumber.value,
        areatypeid:
          formData.roomNumberLocationStatus.value === 'room'
            ? formData.roomNumber.value
            : formData.location.value,
        areatype: formData.roomNumberLocationStatus.value,
        area_id: formData.zoneName.value,
        //hotel_id: "e088d4bf-3fb0-4a61-9cec-78dc9e92e314",
        hotel_id: hotelId,
      };
    }

    try {
      dispatch(stepUpLoaderCount());
      if (category) {
        toggleDrawer('', false, '');
        const response = await updateDevice(devicesEndpoint + '/updatedevice', payload);

        if (response.status) {
          dispatch(fetchDevices(devicesEndpoint + '/getDevices'));
          notificationManager('success', 'Device updated successfully');
        } else {
          if (
            response.message ===
            'Updated UpdateDevice Unsuccessfull UNIQUE constraint failed: device_registry.udid\n'
          ) {
            notificationManager('danger', 'Duplicate Unique number found');
          } else {
            notificationManager('danger', 'Error occurred while updating device');
          }
        }
      } else {
        const response = await updateDevice(devicesEndpoint + '/createdevice', payload);
        if (response.status) {
          dispatch(fetchDevices(devicesEndpoint + '/getDevices'));
          notificationManager('success', 'Device created successfully');
        } else {
          if (response.message === 'device_registry - key already exists') {
            notificationManager('danger', 'Duplicate Unique number found');
          } else {
            notificationManager('danger', 'Error occurred while creating device');
          }
        }
      }
    } catch (err) {
      category
        ? notificationManager('danger', 'Error occurred while updating device')
        : notificationManager('danger', 'Error occurred while creating device');
    } finally {
      dispatch(stepDownLoaderCount());
    }
  };

  useEffect(() => {
    const isValid = formDataValidate(formData, false);
    setIsButtonInValid(!isValid);
  }, [formData]);

  useEffect(() => {
    if (roomListData) setRoomNumbers(roomListData);
  }, [setRoomNumbers, roomListData]);

  useEffect(() => {
    if (locationListData) setLocationList(locationListData);
  }, [setLocationList, locationListData]);

  useEffect(() => {
    if (category) {
      const currFields = { ...formData };
      currFields.roomNumberLocationStatus.value = category.area_type;
      currFields.zoneName.value = category.zone_name;
      currFields.serialNumberUdidStatus.value = category.unique_number_type;
      if (category.area_type === 'room') {
        currFields.roomNumber.value = category.area_type_value;
      } else {
        currFields.location.value = category.area_type_value;
      }

      if (category.unique_number_type === 'serial_no') {
        currFields.serialNumber.value = category.uniquenumber_value;
      } else {
        currFields.udId.value = category.uniquenumber_value;
      }

      setFormData(currFields);
    }
  }, [category]);

  useEffect(() => {
    if (formData.roomNumberLocationStatus.value === 'room') {
      formData.roomNumber.validations = ['required'];
      formData.location.validations = [];
    } else {
      formData.location.validations = ['required'];
      formData.roomNumber.validations = [];
    }
  }, [formData.roomNumberLocationStatus.value]);

  useEffect(() => {
    if (formData.serialNumberUdidStatus.value === 'serial_no') {
      formData.serialNumber.validations = ['required'];
      formData.udId.validations = [];
    } else {
      formData.udId.validations = ['required'];
      formData.serialNumber.validations = [];
    }
  }, [formData.serialNumberUdidStatus.value]);

  const onRoomNumberLocationStatusChange = (e) => {
    formData.roomNumber.validations = ['required'];
    formData.location.validations = ['required'];
    formData.roomNumber.value = '';
    formData.location.value = '';
    const roomNumberLocationStatus = {
      value: e.target.value,
      fieldName: 'Room number Location status',
      validations: [],
      tab: 0,
    };
    setFormData({ roomNumberLocationStatus });
  };

  const onSerialNumberUdidStatusChange = (e) => {
    formData.serialNumber.validations = ['required'];
    formData.udId.validations = ['required'];
    formData.serialNumber.value = '';
    formData.udId.value = '';
    const serialNumberUdidStatus = {
      value: e.target.value,
      fieldName: 'Serial number udid status',
      validations: [],
      tab: 0,
    };
    setFormData({ serialNumberUdidStatus });
  };

  return (
    <form className='device-create' noValidate>
      <div className='container pt-4 d-flex align-items-end flex-column '>
        <div className='row px-3 w-100 mt-4'>
          <div className='col-md-6'>
            <span className='page-title'>{category ? 'Edit Device' : 'Add Device'}</span>
          </div>
          <div className='col-md-6 d-flex justify-content-end'>
            <IconButton aria-label='delete' onClick={(e) => onCancel(e)}>
              <CancelIcon />
            </IconButton>
          </div>
        </div>
        <div className='row px-3 w-100 d-flex mt-2 pt-2'>
          <div className='col-md-12 mb-3'>
            <h4 className='tab-title pb-2'>Details</h4>
            <FormControl>
              <RadioGroup
                row
                aria-labelledby='demo-radio-buttons-group-label'
                defaultValue={formData.roomNumberLocationStatus.value}
                value={formData.roomNumberLocationStatus.value}
                name='radio-buttons-group'
                onChange={(e) => onRoomNumberLocationStatusChange(e)}
              >
                <div className='menu-active-status'>
                  <FormControlLabel
                    value='room'
                    control={<Radio className='radio' />}
                    label='Room number'
                    className='me-5'
                  />
                </div>

                <FormControlLabel value='location' control={<Radio />} label='Location' />
              </RadioGroup>
            </FormControl>
          </div>
        </div>

        <div className='row px-3 w-100 d-flex mt-2 pt-1'>
          <div className='col-md-6 mb-3'>
            {formData.roomNumberLocationStatus.value === 'room' ? (
              <CustomSearchSelect
                item={formData.roomNumber}
                handleInputChange={(e) => {
                  setFormData({ roomNumber: e });
                }}
                options={roomNumbers}
                hideNullOption={true}
                isSearchable={true}
                searchPlaceholder='Search'
                valueField='number'
                labelField='number'
                searchValue={roomSearchValue}
                getSearchInput={onSearchRoomList}
              />
            ) : (
              <CustomSearchSelect
                item={formData.location}
                handleInputChange={(e) => {
                  setFormData({ location: e });
                }}
                options={locationList}
                hideNullOption={true}
                isSearchable={true}
                searchPlaceholder='Search'
                valueField='name'
                labelField='name'
                searchValue={locationSearchValue}
                getSearchInput={onSearchLocationList}
              />
            )}
          </div>
          <div className='col-md-6 mb-2'>
            <CustomTextField
              item={formData.zoneName}
              handleInputChange={(e) => {
                setFormData({ zoneName: e });
              }}
            />
          </div>
        </div>

        <div className='row px-3 w-100 d-flex mt-2 pt-1'>
          <div className='col-md-12 mb-3'>
            <FormControl>
              <RadioGroup
                row
                aria-labelledby='demo-radio-buttons-group-label'
                defaultValue={formData.serialNumberUdidStatus.value}
                value={formData.serialNumberUdidStatus.value}
                name='radio-buttons-group'
                onChange={(e) => onSerialNumberUdidStatusChange(e)}
              >
                <div className='menu-active-status'>
                  <FormControlLabel
                    value='serial_no'
                    control={<Radio className='radio' />}
                    label='Serial number'
                    className='me-5'
                  />
                </div>

                <FormControlLabel value='udid' control={<Radio />} label='UDID' />
              </RadioGroup>
            </FormControl>
          </div>
        </div>

        <div className='row px-3 w-100 d-flex mt-2 pt-1'>
          <div className='col-md-6 mb-3'>
            {formData.serialNumberUdidStatus.value === 'serial_no' ? (
              <CustomTextField
                item={formData.serialNumber}
                handleInputChange={(e) => {
                  setFormData({ serialNumber: e });
                }}
              />
            ) : (
              <CustomTextField
                item={formData.udId}
                handleInputChange={(e) => {
                  setFormData({ udId: e });
                }}
              />
            )}
          </div>
        </div>
        <div className='row mx-2 mt-auto px-4 w-100 pb-5'>
          <div className='col-md-12 d-flex justify-content-start'>
            <Button
              variant='contained'
              color='primary'
              className='me-3'
              size='large'
              disabled={isButtonInValid}
              onClick={handleSubmit}
            >
              {category ? 'Update' : 'Add'}
            </Button>
            <Button
              variant='outlined'
              type='button'
              color='secondary'
              size='large'
              onClick={(e) => onCancel(e)}
            >
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default DevicesCreate;
